import { render, staticRenderFns } from "./FeaturedProject.vue?vue&type=template&id=c9003074&scoped=true&"
import script from "./FeaturedProject.vue?vue&type=script&lang=js&"
export * from "./FeaturedProject.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProject.vue?vue&type=style&index=0&id=c9003074&lang=scss&scoped=true&"
import style1 from "./FeaturedProject.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9003074",
  null
  
)

export default component.exports